export enum ModalType {
  NONE,
  AUTH,
  FEEDBACK,
  SHARE,
  REQUEST_SESSION_ACCESS,
  VIEWER_ACCESS,
  SESSION_FORM,
  CHECKOUT_FORM,
  FREE_TRIAL_END,
  LOBBY_SLUG_FORM,
  USER_SETTINGS,
}

export enum FeedbackModalTypes {
  IN_MEETING,
  POST_MEETING,
}
